import { Fragment } from 'react';

import OrgUnitAdminCredentialsSelectionLargeGrid from './OrgUnitAdminCredentialsSelectionLargeGrid';
import OrgUnitAdminCredentialsSelectionSmallGrid from './OrgUnitAdminCredentialsSelectionSmallGrid';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitAdminCredentialsSelectionGrid = ({ gridData, isLoading, onCheckboxChange }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            {gridData?.length > 499
              ? <p className={global.ErrorMessage}>More than 500 Search Results returned. Please add additional filters to narrow your search results.</p> :
              <p>{gridData?.length === 1 ? `${gridData?.length} Search Result` : `${gridData?.length ? gridData?.length : 0} Search Results`}</p>}
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <OrgUnitAdminCredentialsSelectionLargeGrid
        gridData={gridData || []}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
      />
      <OrgUnitAdminCredentialsSelectionSmallGrid
        gridData={gridData || []}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
      />
    </Fragment>
  )
};

export default OrgUnitAdminCredentialsSelectionGrid;